import { useTranslation } from 'react-i18next'
import { selectSearchContacts } from './searchContactsSelectors'
import { useDispatch, useSelector } from 'react-redux'
import { setSearchResult, updateSearchContactsPhone } from './searchContactsSlice'
import { searchContactsActions } from './searchContactsSagas'
import { useEffect } from 'react'

const useContactSearchPage = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { phone, searchId, loadingResponse, result, resultError, phoneError } = useSelector(selectSearchContacts)
  const setPhone = phoneValue => {
    dispatch(updateSearchContactsPhone(phoneValue))
  }
  const redirectWhenSingleResult = data => {
    window.location = '/contact/add?id=' + data?.zoho_id + '&phone=' + (data?.phone || phone)
  }
  const triggerSearchClient = () => {
    if (!phone) {
      return
    }
    dispatch({ type: searchContactsActions.TRIGGER_SEARCH, redirectWhenSingleResult })
  }

  useEffect(() => {
    if (!searchId) return

    window.Echo.channel(`search-contact.${searchId}`)
      .listen('.operation.success', event => {
        console.log('Search contact operation success:', event)
        console.log('Event data:', typeof event.data)
        if (event.data?.length === 1) {
          redirectWhenSingleResult(event.data[0])
          return
        }
        dispatch(setSearchResult(event.data || []))
        window.Echo.leaveChannel(`search-contact.${searchId}`)
      })
      .listen('.operation.failed', event => {
        console.error('Search contact operation failed:', event)
        window.Echo.leaveChannel(`search-contact.${searchId}`)
      })
  }, [searchId])

  return {
    t,
    searchId,
    loadingResponse,
    result,
    resultError,
    phoneError,
    triggerSearchClient,
    setPhone,
    redirectWhenSingleResult,
  }
}

export default useContactSearchPage
